// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-ai-audits',
//   standalone: true,
//   imports: [],
//   templateUrl: './ai-audits.component.html',
//   styleUrl: './ai-audits.component.scss'
// })
// export class AiAuditsComponent {

// }
import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilteredAuditsList } from '@app/_entities/filtered-list';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, map, lastValueFrom } from 'rxjs';

import { InteractionDetailsComponent } from '../interactions/interaction-details/interaction-details.component';
import { SecurityService } from './../../../_core/services/security.service';
import { saveAs as fileSaverSave } from 'file-saver';

@Component({
  selector: 'app-ai-audits',
  templateUrl: './ai-audits.component.html',
  styleUrls: ['./ai-audits.component.scss'],
})
export class AiAuditsComponent implements OnInit, OnDestroy {
  constructor(
    private utils: Utils,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private auditorService: AuditorService,
    private securityService: SecurityService,
    private webStorage: WebStorageService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) { }

  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  //showTable: boolean = true;
  // showCrud: boolean = false;

  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;
  showDateRange: boolean = true;
  first = 0;
  auditList: any = [];
  localStorageName = 'AIAuditsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };
  commentDialogVisible = false;
   selectedRow: any;
   aiReviewComments: any[] = [];
  getAuditsTimeout: any;
  /*globalfilter*/
  findOptions: any = [
    // { value: 'Agent', label: 'Agent' },
    // { value: 'Group', label: 'Group' },
    // { value: 'Manager', label: 'Manager' },
    // { value: 'Auditor', label: 'Auditor' },
    // { value: 'Status', label: 'Status' },
    // { value: 'SurveyForm', label: 'Survey Form' },
    { value: 'FirstName', label: 'Agent First Name' },
    { value: 'LastName', label: 'Agent Last Name' },
    { value: 'SurveyID', label: 'SurveyID' },
    { value: 'InteractionID', label: 'Interaction ID' },
  ];

  rowOffset = 0;
  rowCount = 10;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = null;
  sortColumn = 'Date';
  sortDescend = true;
  filterOptionRequestColumn = null;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  pl: any = {};
  filteredAuditList = new FilteredAuditsList();

  cols: any = [
    { name: 'ID', label: 'ID', type: 'numeric' },
    { name: 'Agent', label: 'Agent', showFilter: true },
    { name: 'Group', label: 'Group', showFilter: true },
    { name: 'InteractionID', label: 'Interaction ID', showFilter: false,minWidth: 8 },
    { name: 'Status',label: 'Human Review<br>Status', showFilter: true, minWidth: 8},
    // { name: 'AI Score', label: 'AI Score', showFilter: false },
    { name: 'Score', label: 'Final Score', showFilter: true,minWidth: 8 }, 
    { name: 'Manager', label: 'Manager', showFilter: true, format: 'name',minWidth: 8 },
    { name: 'Auditor', label: 'Auditor', showFilter: true, format: 'name' },
    { name: 'Date', label: 'Date', type: 'date', showFilter: false },
    { name: 'SurveyForm', label: 'Survey Form', showFilter: true },
    { name: 'Type', label: 'Type', showFilter: false },
    //{ name: 'Comments, Evaluations & Recommendations', label: 'Comments, Evaluations & Recommendations', showFilter: false },
    { name: 'AI Comments/Recommendations', label: 'AI Comments / Recommendations', showFilter: false },
    { name: 'Download', label: 'Download', showFilter: false },
    
  ];

  aiCols = [
    // { name: 'AI Evaluation Status', label: 'AI Evaluation Status', showFilter: false },
    // { name: 'AI Score', label: 'AI Score', showFilter: false },
    // { name: 'Human Validation Status & Score', label: 'Human Validation Status & Score', showFilter: false },
   // { name: 'Comments, Evaluations & Recommendations', label: 'Comments, Evaluations & Recommendations', showFilter: false },
  ]

  ngOnInit(): void {
    const clientAbbreviation = Utils.fetch('clientAbbreviation') || '';
    const isAIAudits = JSON.parse(Utils.fetch('IsAIAudits'));
    if (!isAIAudits) {
      this.router.navigate([clientAbbreviation + '/Console/Auditing/Audits']);
    }
    this.fromDate.setMonth(this.fromDate.getMonth() - 6);
    //this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
      isAIAudit: true,
    };
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      if(this.currentMenu?.name == 'AIAudits'){
        this.currentMenu.name = 'AI'+' '+'Audits';
      }
      this.action = this.currentMenu?.name;
    });

    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
    //this.loadAudits();
  }

  ngOnDestroy(): void {
    if (this.getAuditsTimeout) {
      clearTimeout(this.getAuditsTimeout);
    }
  }

  applySelectedDateRange(val) {
    this.toDate = val.toDate;
    this.fromDate = val.fromDate;
    this.loadAudits(null);
  }

  // resetDateRange() {
  //   this.toDate = new Date();
  //   this.fromDate = new Date();
  //   this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
  //   this.loadAudits(null);
  // }
  resetDateRange(event: any) 
  {
    this.fromDate = event.fromDate;
    this.toDate = event.toDate;
    this.loadAudits(null);
  }
  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      //this.cols = localCol;
      this.cols = [...localCol, ...this.aiCols];
    } else {
      this.cols = [...this.cols, ...this.aiCols];
      for (const col of this.cols) {
        if (col.name == this.sortColumn) {
          if (this.sortDescend) {
            col.isAsc = false;
          } else {
            col.isAsc = true;
          }
        } else {
          delete col.isAsc;
        }
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    this.pl['searchField'] = { label: '', value: '' };
    this.loadAudits(null);
  }
  clearFilter() {
    this.cols.forEach((col: any) => {
      delete col.filterVals;
    });
    this.loadAudits(null);
    this.auditList = this.applyColumnFilters();
  }

  applyFilterByField(val: any) {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.pl['searchField'] = this.searchField.value;
    this.pl['searchValue'] = this.searchValue;
    this.loadAudits(null);
  }

  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    this.filterOptionRequestColumn = colName;
    this.loadAudits(null);
  }

  showColumnFilterModal(colName: string) {
    this.cdr.detectChanges();
    this.getColDetails(this.cols, this.filteredAuditList);

    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.cdr.detectChanges();
      //this.storeFilteredList(this.cols, colName);
      this.applyColumnFilters();
    });
  }

  storeFilteredList(colData, colName) {
    switch (colName) {
      case 'Agent':
        this.filteredAuditList.agent = colData.filterVals;
        break;
      case 'Group':
        this.filteredAuditList.group = colData.filterVals;
        break;
      case 'Manager':
        this.filteredAuditList.manager = colData.filterVals;
        break;
      case 'Auditor':
        this.filteredAuditList.auditor = colData.filterVals;
        break;
      case 'SurveyFrom':
        this.filteredAuditList.surveyFrom = colData.filterVals;
        break;
      case 'Status':
        this.filteredAuditList.status = colData.filterVals;
        break;
    }
  }

  getFilteredList(colName) {
    switch (colName) {
      case 'Agent':
        return this.filteredAuditList.agent;
      case 'Group':
        return this.filteredAuditList.group;
      case 'Manager':
        return this.filteredAuditList.manager;
      case 'Auditor':
        return this.filteredAuditList.auditor;
      case 'SurveyFrom':
        return this.filteredAuditList.surveyFrom;
      case 'Status':
        return this.filteredAuditList.status;
    }
    return null;
  }

  getColDetails(cols, filteredList) {
    if (filteredList) {
      for (const col of cols) {
        if (col.name == 'Agent') {
          if (filteredList.agent.length > 0) {
            col.filterVals = filteredList.agent;
          }
        }
        if (col.name == 'Group') {
          if (filteredList.group.length > 0) {
            col.filterVals = filteredList.group;
          }
        }
        if (col.name == 'Manager') {
          if (filteredList.manager.length > 0) {
            col.filterVals = filteredList.manager;
          }
        }
        if (col.name == 'Auditor') {
          if (filteredList.auditor.length > 0) {
            col.filterVals = filteredList.auditor;
          }
        }
        if (col.name == 'SurveyFrom') {
          if (filteredList.surveyFrom.length > 0) {
            col.filterVals = filteredList.surveyFrom;
          }
        }
        if (col.name == 'Status') {
          if (filteredList.status.length > 0) {
            col.filterVals = filteredList.status;
          }
        }
      }
    }
  }

  /*column level filter*/
  applyColumnFilters() {
    //apply column filter here and assign to dataTodisplay
    this.filterDict = [];
    // filterDict: [{Key: "Queue", Value: ["Search"]}]
    this.filterOptionRequestColumn = null;
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name.toString());
          }
        }
        this.filterDict.push({ Key: this.correctFilterColumnName(colData.name), Value: filterVals });
      }
    }
    this.pl.filterDict = this.filterDict;
    this.loadAudits(null);
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadAudits(null);
  }

  onRowSelect_AI(event: any) {
    let interactionId =  event.data.InteractionID;
    let surveyId =  event.data.SurveyID;
    let clientAbbreviation = Utils.fetch('clientAbbreviation') || '';
    //this.router.navigate([clientAbbreviation + '/Console/Auditing/Interactions/AI', interactionId]);
    this.router.navigate([clientAbbreviation + '/Console/Auditing/AIInteractions', interactionId],
       {
           queryParams: { source: 'AIAudits', surveyId: surveyId }
         }
     );

  }

  formatKey(key: string): string {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
  }

  openCommentPopup(rowData: any) { 
    this.selectedRow = rowData; 
    this.commentDialogVisible = true; 

    this.aiReviewComments = Object.entries(rowData?.AIReviewComments || {}).map(
      ([key, value]) => ({
        key,
        value,
        isArray: Array.isArray(value)
      })
    );
  }
  onRowSelect(event: any) {
   // console.log(event);

    const initialState = {
      interactionId: event.data.InteractionID,
    };
    const config: ModalOptions = {
      backdrop: 'static',
      class: 'interactionDetails-Auditmenu',
      initialState,
    };
    this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    // this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
  }

  loadAudits(event: TableLazyLoadEvent) {
    this.loading = true;
    if (event == null) {
      this.resetTable();
    } else {
      this.pl.rowOffset = event.first;
      this.pl.rowCount = event.rows;
    }
    this.getAuditsTimeout = setTimeout(
      () => {
        //load data of required page
        if (this.filterOptionRequestColumn != null) {
          this.pl.filterOptionRequestColumn = this.correctFilterColumnName(this.filterOptionRequestColumn);
        } /*else {
        this.pl['filterOptionRequestColumn'] = '';
      }*/
        this.auditorService
          .GetAudits(this.pl)
          .pipe(
            map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetAudits');
              if (isValid) {
                if (this.pl['filterOptionRequestColumn'] != null) {
                  const columnName = this.pl['filterOptionRequestColumn'];
                  this.pl['filterOptionRequestColumn'] = null;
                  const filterVals = [];
                  for (const dt of data.Response.Data) {
                    if (dt != null && dt.trim() != '') {
                      filterVals.push({ name: dt, checked: false });
                    }
                  }
                  for (const col of this.cols) {
                    if (col.name == columnName || col.label == columnName) {
                      col.filterVals = filterVals;
                    }
                  }
                  this.showColumnFilterModal(columnName);
                } else {
                  this.auditList = data.Response.Data.Data;
                  if (data.Response.Data.TotalFilteredItems) {
                    this.totalRecords = data.Response.Data.TotalFilteredItems;
                  } else {
                    this.totalRecords = 0;
                  }
                  this.loading = false;
                }
                //trigger change detection
                event.forceUpdate();
                this.setInnerWidthHeightParameters();
              } else {
              }
            }),
            catchError(error => {
              this.loading = false;
              return EMPTY;
            })
          )
          .subscribe();
      },
      Math.random() * 1000 + 250
    );
  }

  resetTable() {
    this.first = 0;
    // this.auditList = [];
    // this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    this.pl['filterDict'] = this.filterDict;
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['filter'] = {
      FromDate: new Date(this.fromDate).getTime(),
      ToDate: new Date(this.toDate).getTime(),
    };
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    this.pl['searchField'] = this.searchField.value;
  }
  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }

correctFilterColumnName(colName: string): any {
    let key = colName;
    if(colName == 'SurveyForm'){
      key = 'Survey Form';
    }
    return key;
  }
  async getExportExcel(surveyId: number | string) {
    const excelRes: any = await lastValueFrom(this.auditorService.getExportExcel(surveyId));
    const toConvert = excelRes.result; //supply your full plain string here
    const file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${toConvert}`;
    fileSaverSave.saveAs(file, excelRes?.fileName);
  }
}
